//测算
export default [

    {   //成本测算
        path: "chargescalc/cost",
        name: "chargescalcCost",
        component: () => import(/* webpackChunkName: "chargescalc" */ "@/views/chargescalc/cost/index"),
    },
//库内费用类型维护
    {
        path: "pay/storebilltype/list",
        name: "payStoreBillType",
        component: () => import(/* webpackChunkName: "chargescalc" */ "@/views/chargescalc/storebilltype/index"),
    },
    {
        path: "pay/storebilltype/detail/:type",
        name: "payStoreBillTypeDetail",
        component: () => import(/* webpackChunkName: "chargescalc" */ "@/views/chargescalc/storebilltype/update"),
    },
//库内收费价格维护
    {
        path: "pay/pricemaintain/list",
        name: "payPricemaintain",
        component: () => import(/* webpackChunkName: "chargescalc" */ "@/views/chargescalc/pricemaintain/index"),
    },
    {
        path: "pay/pricemaintain/detail/:type",
        name: "payPricemaintainDetail",
        component: () => import(/* webpackChunkName: "chargescalc" */ "@/views/chargescalc/pricemaintain/update"),
    },
//账期维护
    {
        path: "pay/paymentmaintain/list",
        name: "paymentmaintainPricemaintain",
        component: () => import(/* webpackChunkName: "chargescalc" */ "@/views/chargescalc/paymentmaintain/index"),
    },
    {
        path: "pay/paymentmaintain/detail/:type",
        name: "paymentmaintainPricemaintainDetail",
        component: () => import(/* webpackChunkName: "chargescalc" */ "@/views/chargescalc/paymentmaintain/update"),
    },
//费用账单汇总
    {
        path: "pay/billsummary/list",
        name: "payBillSummary",
        component: () => import(/* webpackChunkName: "chargescalc" */ "@/views/chargescalc/billsummary/index"),
    },
//费用账单明细
    {
        path: "pay/storageorder/billdetail",
        name: "payStorageBilldetail",
        component: () => import(/* webpackChunkName: "chargescalc" */ "@/views/chargescalc/billdetail/index"),
    },
//费用结算明细
    {
        path: "pay/storageorder/billorder",
        name: "payStorageBillOrder",
        component: () => import(/* webpackChunkName: "chargescalc" */ "@/views/chargescalc/billorder/index"),
    },
//应付尾程账单
    {
        path: "pay/expressfee",
        name: "payStorageBillOrder",
        component: () => import(/* webpackChunkName: "chargescalc" */ "@/views/chargescalc/expressfee/index"),
    },
//应付费用调账
    {
        path: "pay/feeadjust/list",
        name: "payFeeAdjustList",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/chargescalc/feeadjust/index"),
    },
//库内费用重处理
    {
        path: "pay/feeprocess/rehandle",
        name: "payFeeProcessRehandle",
        component: () => import(/* webpackChunkName: "newbigaccount" */ "@/views/chargescalc/feeprocess/rehandle"),
    },
//库内账单生成异常
    {
        path: "pay/billexception",
        name: "payBillException",
        component: () => import(/* webpackChunkName: "newbigaccount" */ "@/views/chargescalc/billexception/index"),
    },
]


